const pageToCursor = (page, pageSize) => {
  return window.btoa(`arrayconnection:${(page - 1) * pageSize - 1}`);
};

export default pageToCursor;



// WEBPACK FOOTER //
// ./src/utils/pageToCursor.js